import createDebug from "debug";
import { AuthService } from "../services/auth/auth.service";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CanActivateFn, Router } from "@angular/router";

const debug = createDebug("roleGuard");

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const snackBar = inject(MatSnackBar);
  return (async () => {
    debug("checking auth");
    const authEnabled = await authService.getAuthEnabled();
    debug("authEnabled", authEnabled);

    const user = await authService.getCurrentUser();

    if (!user) {
      if (!authEnabled) {
        return true;
      }
      const rejected = await authService.getRejected();
      const unauthRedirect = authService.getLoginPath();
      debug(
        "not authenticated, rejected %s, current url %s, redirect %s",
        rejected,
        state.url,
        unauthRedirect,
      );
      if (!rejected && !state.url.startsWith(unauthRedirect)) {
        authService.returnUrl = state.url;
        router.navigate([unauthRedirect]);
      }
      return false;
    }

    const requiredRoles: string[] = route.data["roles"] ?? [];
    debug("requiredRoles", requiredRoles);

    if (requiredRoles.length === 0) {
      return true;
    }

    for (const role of requiredRoles) {
      const hasRole = await authService.hasRole(role);
      if (hasRole) {
        debug("has role", role);
        return true;
      }
    }

    debug("missing required role");
    snackBar.open("You do not have permission to access this page.", "OK", {
      duration: 5000,
    });
    return false;
  })();
};
